import { render, staticRenderFns } from "./CveCvssScoreTableCell.vue?vue&type=template&id=4fb7b216&scoped=true"
import script from "./CveCvssScoreTableCell.vue?vue&type=script&lang=js"
export * from "./CveCvssScoreTableCell.vue?vue&type=script&lang=js"
import style0 from "./CveCvssScoreTableCell.vue?vue&type=style&index=0&id=4fb7b216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7b216",
  null
  
)

export default component.exports